module.exports = __webpack_public_path__ + "img/courier_4.e5b9c8c2.png";